export default __webpack_public_path__ + "static/main1-ad23ebc1f638a66770d14efbfa9e133d.png";